import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const FormationDocuments: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={2}>Выберите раздел</Typography>
                    <Typography mb={1} ml={10}>Общие сведения</Typography>
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={10}>Период с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <Typography mr={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px" }} 
                    />
                    <Typography mr={1} ml={10}>на дату</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px" }} 
                    />
                </Box>

                <Box>
                    <FormControlLabel
                        label="персонал"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="специальность"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="амбулант(вид помощи)"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="хозрасчет"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="<все работники>"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>

                <Box>
                    <FormControlLabel
                        label="подразделения"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="должность"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="стационар"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="ОМС"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="Основные"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>

                <Box>
                    <FormControlLabel
                        label="отделение"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="дн.стационар"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="бюджет"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="внутренние совместители"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>

                <Box>
                    <FormControlLabel
                        label="кабинет, палата"
                        control={<Checkbox defaultChecked />}
                    />
                    <FormControlLabel
                        label="не заполнен вид помощи"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography mr={1}>Поиск</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px" }} 
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default FormationDocuments;